import { isIosShell } from './platform';

/** Neutral iOS copy (#408) — App Store 3.1.3(a): no price, no purchase call to action, no outside purchase page. */
export const IOS_SUBSCRIPTION_MANAGE_MESSAGE = "Account and membership changes aren't available in this app.";
export const IOS_SUBSCRIPTION_MANAGE_KEY = 'ios.store.accountNote'; // i18n/iosStoreI18n.js, all languages

/** Standalone billing routes that must not render commerce UI in the iOS shell. */
export const IOS_COMMERCE_PATHS = [
  '/subscribe',
  '/billing',
  '/manage-subscription',
  '/welcome-back',
] as const;

export function isIosCommercePath(pathname: string): boolean {
  const p = String(pathname || '').replace(/\/+$/, '') || '/';
  if (p === '/subscribe' || p.startsWith('/subscribe/')) return true;
  return (IOS_COMMERCE_PATHS as readonly string[]).includes(p);
}

/** True when Maestro billing/checkout/portal actions must be blocked in the iOS shell. */
export function isIosCommerceBlocked(): boolean {
  return isIosShell();
}
